import React, { useEffect, useState } from 'react';
import { obtenerTransferencia, editarTransferencia, eliminarTransferencia, obtenerCuentas, iconoTipo } from '../services/cuentasService';
import { mensajeAmigable } from '../utils/errores';
import { aNumero } from '../utils/validacion';
import CampoNumero from './CampoNumero';
import { useToast } from '../context/ToastContext';

// Corrige (o elimina) una transferencia entre cuentas. El dinero se ajusta
// solo en ambas cuentas (reverso atómico).
export default function EditarTransferenciaModal({ referencia, onCerrar, onGuardado }) {
  const { mostrarToast } = useToast();
  const [form, setForm] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [confirmar, setConfirmar] = useState(false);

  useEffect(() => {
    Promise.all([obtenerTransferencia(referencia), obtenerCuentas()])
      .then(([t, cs]) => {
        setCuentas(cs);
        setForm({ origen: t.origen, destino: t.destino, monto: String(t.monto || ''), descripcion: t.descripcion || '' });
      })
      .catch((e) => setError(mensajeAmigable(e)));
  }, [referencia]);

  const guardar = async () => {
    if (!form.origen || !form.destino) { mostrarToast('Elige cuenta origen y destino', 'error'); return; }
    if (form.origen === form.destino) { mostrarToast('Deben ser cuentas distintas', 'error'); return; }
    if (!(aNumero(form.monto) > 0)) { mostrarToast('Escribe el monto (solo números, mayor que 0)', 'error'); return; }
    setGuardando(true);
    try {
      await editarTransferencia(referencia, form);
      mostrarToast('Transferencia corregida ✅', 'exito');
      onGuardado?.(); onCerrar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
    finally { setGuardando(false); }
  };

  const borrar = async () => {
    setGuardando(true);
    try {
      await eliminarTransferencia(referencia);
      mostrarToast('Transferencia eliminada. Dinero devuelto ✅', 'exito');
      onGuardado?.(); onCerrar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
    finally { setGuardando(false); }
  };

  const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
  const label = { fontSize: '12px', color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: '4px' };

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1200 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '440px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', backgroundColor: '#EFF6FF', borderRadius: '16px 16px 0 0' }}>
          <h3 style={{ margin: 0, color: '#2563EB', fontSize: '18px' }}>🔄 Editar transferencia</h3>
          <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#6B7280' }}>El dinero se ajusta solo en ambas cuentas.</p>
        </div>
        <div style={{ padding: '20px' }}>
          {error && <p style={{ color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
          {!form && !error && <p style={{ color: '#6B7280', textAlign: 'center', padding: '20px' }}>⏳ Cargando...</p>}
          {form && (
            <>
              <div style={{ marginBottom: '12px' }}>
                <label style={label}>Desde (sale el dinero)</label>
                <select value={form.origen} disabled={guardando} onChange={(e) => setForm({ ...form, origen: e.target.value })} style={input}>
                  <option value="">Elige...</option>
                  {cuentas.map((c) => <option key={c.id} value={c.id}>{iconoTipo(c.tipo)} {c.nombre}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={label}>Hacia (entra el dinero)</label>
                <select value={form.destino} disabled={guardando} onChange={(e) => setForm({ ...form, destino: e.target.value })} style={input}>
                  <option value="">Elige...</option>
                  {cuentas.map((c) => <option key={c.id} value={c.id}>{iconoTipo(c.tipo)} {c.nombre}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={label}>Monto (L)</label>
                <CampoNumero valor={form.monto} onChange={(v) => setForm({ ...form, monto: v })} deshabilitado={guardando}
                  min={0} prefijo="L" placeholder="0.00" estilo={input} />
              </div>
              <div style={{ marginBottom: '18px' }}>
                <label style={label}>Nota (opcional)</label>
                <input value={form.descripcion} disabled={guardando} onChange={(e) => setForm({ ...form, descripcion: e.target.value })} style={input} placeholder="Ej. Pago tarjeta" />
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={guardar} disabled={guardando}
                  style={{ flex: 1, padding: '12px', backgroundColor: guardando ? '#9CA3AF' : '#2563EB', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: guardando ? 'wait' : 'pointer' }}>
                  {guardando ? '⏳...' : 'Guardar cambios'}
                </button>
              </div>
              {confirmar ? (
                <div style={{ marginTop: '10px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <span style={{ fontSize: '13px', color: '#991B1B', flex: 1 }}>¿Eliminar la transferencia?</span>
                  <button onClick={borrar} disabled={guardando} style={{ padding: '8px 12px', backgroundColor: '#DC2626', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>Sí, borrar</button>
                  <button onClick={() => setConfirmar(false)} disabled={guardando} style={{ padding: '8px 12px', backgroundColor: 'white', color: '#6B7280', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '13px', cursor: 'pointer' }}>No</button>
                </div>
              ) : (
                <button onClick={() => setConfirmar(true)} disabled={guardando}
                  style={{ width: '100%', marginTop: '10px', padding: '10px', backgroundColor: 'white', color: '#DC2626', border: '1px solid #FCA5A5', borderRadius: '10px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
                  🗑️ Eliminar transferencia
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
